<!--
    - HTML Code to change existing password
    - resetPassword() is called when user has enter new password twice correctly
    - cancelback() is called if user does not want to update his password
    - Error message is displayed if both passwords does not matches
    - Commented by sarthak on feb 12, 2024
 -->
<!-- <div class="container login_container change_pw_outer text-center">
    <form [formGroup]="userForm" (ngSubmit)="resetPassword()">
        <div class="row">
            <div class="mx-auto custom_mx">
                <div class="login_outer">
                            <h2>Change Password</h2>
                            <p class="text-muted"> Password must contain at least one uppercase number and special
                                character. </p>

                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text no_radius"><i class="material-icons">lock</i>
                                    </span>
                                </div>
                                <input type="password" class="form-control" placeholder="New password"
                                    formControlName="new_password" id="new_password">
                                <control-messages class="err-msg" [control]="userForm.controls.new_password">
                                </control-messages>
                            </div>

                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text no_radius"><i class="material-icons">lock</i>
                                    </span>
                                </div>
                                <input type="password" class="form-control" placeholder="Confirm password"
                                    formControlName="confirm_password" id="confirm_password">
                                <p class="err-msg">{{msgInfo}}</p>
                                <control-messages class="err-msg" [control]="userForm.controls.confirm_password">
                                </control-messages>
                            </div>

                            <div class="text-center">
                                <button class="btn_my_login" mat-raised-button type="submit"
                                    [disabled]="!userForm.valid">Reset</button>
                            </div>
                </div>
            </div>
        </div>
    </form>
</div> -->

<!-- ------New design of Change password screen------ -->
<div class="breadcrumb_outer">
  <ul class="breadcrumb">
    <li><a>{{company_name}}:</a></li>
    <li class="active"><a>Change Password</a></li>
  </ul>
  <div class="right">
    <span>{{today}}</span>
  </div>
</div>
<div class="tag_powered_by">
  <span>Powered by: <b>Enertics</b></span>
</div>

<!-- Main content centered in page -->
<div class="Content_outer center-page">
  <div class="content-heading">
    <h4>Change Password</h4>
    <hr>
  </div>
  <div class="content_view">
    <div class="password-containers">
      <div class="change_pass_outer gray-container">
        <h2>Password Guidelines</h2>
        <div class="info-content">
          <p>For your security, please ensure your password meets these requirements:</p>
          <ul>
            <li>Minimum 8 characters in length</li>
            <li>At least one uppercase letter</li>
            <li>At least one number</li>
            <li>At least one special character</li>
          </ul>
        </div>
      </div>
      <!-- Change Password Container -->
      <div class="change_pass_outer">
        <h2>Change Password</h2>
        <form [formGroup]="userForm" (ngSubmit)="resetPassword()">
          <div class="form-group">
            <label>New Password</label>
            <input type="password" class="form-control" formControlName="new_password" id="new_password">
          </div>
          <div class="form-group">
            <label>Confirm Password</label>
            <input type="password" class="form-control" formControlName="confirm_password" id="confirm_password">
            <p class="err-msg m_0">{{msgInfo}}</p>
          </div>
          <div class="action text-right">
            <button mat-raised-button color="primary" type="submit" [disabled]="!userForm.valid">Change Password</button>
            <button color="warn" mat-stroked-button (click)="cancelback()">Cancel</button>
          </div>
        </form>
      </div>

      <!-- Gray Guidelines Container -->
      <!-- <div class="change_pass_outer gray-container">
        <h2>Password Guidelines</h2>
        <div class="info-content">
          <p>For your security, please ensure your password meets these requirements:</p>
          <ul>
            <li>Minimum 8 characters in length</li>
            <li>At least one uppercase letter</li>
            <li>At least one number</li>
            <li>At least one special character</li>
          </ul>
        </div>
      </div> -->
    </div>
  </div>
</div>
  <!-- ---------- -->